<template lang='pug' src='./Month.pug'></template>

<script>
  import dateFunc from './dateFunc'
  import BookHolidayPopup from '../BookHolidayPopup/BookHolidayPopup'
  import langSets from './langSets'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Month',
    components: {
      BookHolidayPopup
    },
    props: {
      currentDate: {},
      events: null,
      isHolidaysCalendar: Boolean
    },
    created () {
      this.dispatchEvent()
    },
    data () {
      return {
        titleFormat: langSets.titleFormat,
        monthNames: langSets.monthNames,
        firstDay: 1,
        weekMask: [1, 2, 3, 4, 5, 6, 7],
        eventLimit: 1,
        morePos: {
          top: 0,
          left: 0
        },
        remainDays: 0,
        title: '',
        headDate: this.currentDate,
        showMore: false,
        selectDay: [],
        month: 0,
        fridayNumber: 4,
        mondayNumber: 0,
        saturdayNumber: 6,
        daysOfWeek: 7,
        classHoliday: 'holiday',
        classPublic: 'public',
        classNewHoliday: 'newHoliday',
        classNewHolidayPublic: 'newHolidayPublic',
        formatDate: 'yyyy-MM-dd',
        boxTop: false,
        boxLeft: false,
        workingDays: 0,
        holidayName: '',
        showOnly: false
      }
    },
    computed: {
      ...mapGetters([
        'getNewVacations',
        'getNewHolidays',
        'getSelectDay',
        'getStartDate',
        'getEndDate',
        'getBookedDays',
        'getShowMore',
        'getEditingId',
        'getSelectedYear',
        'getMe'
      ]),
      weekNames () {
        let arr = langSets.weekNames
        return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay))
      },
      currentDates () {
        return this.getCalendar()
      },
      firstDay (val) {
        let res = parseInt(val)
        return res >= this.mondayNumber && res <= this.saturdayNumber
      },
      newEvents () {
        if (this.isHolidaysCalendar) {
          let newVacations = {}
          if (this.getNewVacations.length) {
            newVacations = this.getNewVacations.map(vacations => {
              return {
                start: vacations.startDate,
                end: vacations.endDate,
                cssClass: this.classNewHoliday
              }
            })
          }
          return newVacations
        } else {
          let newHolidays = {}
          if (this.getNewHolidays.length) {
            newHolidays = this.getNewHolidays.map(holidays => {
              return {
                start: holidays.date,
                end: holidays.date,
                cssClass: this.classNewHolidayPublic
              }
            })
          }
          return newHolidays
        }
      }
    },
    methods: {
      ...mapActions([
        'setSelectDay',
        'setStartDate',
        'setEndDate',
        'setShowMore',
        'updateEvents',
        'setEditingId',
        'cancelHolidays',
        'cancelRemove'
      ]),
      changeShow () {
        this.showOnly = false
      },
      isOpened () {
        return (this.getShowMore === this.title)
      },
      getCalendar () {
        // calculate 2d-array of each month
        // first day of this month
        let now = new Date() // today
        now.setHours(0, 0, 0, 0)
        let current = new Date(this.currentDate)

        let startDate = dateFunc.getStartDate(current) // 1st day of this month

        let curWeekDay = startDate.getDay()

        // begin date of this table may be some day of last month
        let diff = parseInt(this.firstDay) - curWeekDay
        diff = diff > this.mondayNumber ? (diff - this.daysOfWeek) : diff

        startDate.setDate(startDate.getDate() + diff)
        let calendar = []

        for (
          let perWeek = this.mondayNumber;
          perWeek < this.saturdayNumber;
          perWeek++
        ) {
          let week = []

          for (
            let perDay = this.mondayNumber;
            perDay < this.daysOfWeek;
            perDay++
          ) {
            week.push({
              monthDay: startDate.getDate(),
              isToday: now.toDateString() === startDate.toDateString(),
              isFutureDate: startDate > now,
              isCurMonth: startDate.getMonth() === current.getMonth(),
              weekDay: perDay,
              date: new Date(startDate),
              events: this.slotEvents(startDate, this.events),
              newVacations: this.slotEvents(startDate, this.newEvents)
            })

            startDate.setDate(startDate.getDate() + 1)
            // if (startDate.toDateString() == endDate.toDateString()) {
            //   isFinal = true
            //   break
            // }
          }
          calendar.push(week)
          // if (isFinal) break
        }

        return calendar
      },
      slotEvents (date, events) {
        // find all events start from this date
        // let cellIndexArr = []
        if (!events.length) {
          return false
        }

        let thisDayEvents = events.filter(day => {
          let dt = new Date(day.start)
          let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
          let ed = day.end ? new Date(day.end) : st
          return date >= st && date <= ed
        }).sort((a, b) => {
          if (!a.cellIndex) return 1
          if (!b.cellIndex) return -1
          return a.cellIndex - b.cellIndex
        })
        // mark cellIndex and place holder
        for (let i = 0; i < thisDayEvents.length; i++) {
          thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || (i + 1)
          thisDayEvents[i].isShow = true
          if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue
          thisDayEvents.splice(i, 0, {
            cellIndex: i + 1,
            start: dateFunc.format(date, this.formatDate),
            end: dateFunc.format(date, this.formatDate)
          })
        }

        return thisDayEvents
      },
      isStart (eventDate, date) {
        let st = new Date(eventDate)
        return st.toDateString() === date.toDateString()
      },
      isEnd (eventDate, date) {
        let ed = new Date(eventDate)
        return ed.toDateString() === date.toDateString()
      },
      isHoliday (eventDate, date) {
        if (!eventDate) {
          return false
        }
        if (eventDate.cssClass === this.classHoliday) {
          return true
        }
        return false
      },
      isNewHoliday (eventDate, date) {
        if (!eventDate) {
          return false
        }
        if (eventDate.cssClass === this.classNewHoliday) {
          return true
        }
        return false
      },
      isNewHolidayPublic (eventDate, date) {
        if (!eventDate) {
          return false
        }
        if (eventDate.cssClass === this.classNewHolidayPublic) {
          return true
        }
        return false
      },
      isPublic (eventDate, date) {
        if (!eventDate) {
          return false
        }
        if (eventDate.cssClass === this.classPublic) {
          return true
        }
        return false
      },
      selectThisDay (day, jsEvent) {
        let currentDay = dateFunc.format(day.date, this.formatDate)
        if (day.weekDay > this.fridayNumber || !day.isCurMonth) {
          return false
        }

        if (this.isHolidaysCalendar &&
            !day.isFutureDate &&
            day.events.length === 0) {
          return false
        }

        this.holidayName = ''
        if (day.events.length) {
          day.events.filter(e => {
            if (e.cssClass === this.classPublic) {
              this.morePos = this.computePos(jsEvent.target)
              this.cancelHolidays(this.isHolidaysCalendar)
              this.cancelRemove()
              this.selectDay = this.getSelectDay
              this.holidayName = e.name
              if (!this.isHolidaysCalendar) {
                this.setEditingId(e.start)
              } else {
                this.showOnly = true
              }
            }
            if (e.cssClass === this.classHoliday) {
              this.cancelHolidays(this.isHolidaysCalendar)
              this.cancelRemove()
              this.setEditingId(e.id)
              this.selectDay = this.getSelectDay
              this.workingDays = e.workingDays
              this.morePos = this.computePos(jsEvent.target)
            }
          })

          if (!this.getShowMore) {
            this.showMore = true
          }

          if (this.showMore && !this.getStartDate) {
            this.setShowMore(this.title)
            this.morePos = this.computePos(jsEvent.target)
          }

          this.setStartDate(day.events[0].start)
          this.setEndDate(day.events[0].end)
        } else {
          if (day.newVacations.length) {
            day.events.filter(e => {
              if (e.cssClass === this.classPublic) {
                return false
              }
            })

            this.selectDay = this.getSelectDay
            if (this.selectDay[0] !== currentDay) {
              this.setSelectDay([
                day.newVacations[0].start,
                dateFunc.format(currentDay, this.formatDate)])

              this.setStartDate(
                dateFunc.format(day.newVacations[0].start, this.formatDate)
              )
              this.setEndDate(
                dateFunc.format(currentDay, this.formatDate)
              )
              this.updateEvents(this.isHolidaysCalendar)
            } else {
              this.setStartDate(
                dateFunc.format(day.newVacations[0].start, this.formatDate)
              )
              this.setEndDate(
                dateFunc.format(day.newVacations[0].end, this.formatDate)
              )
            }
          } else {
            if (this.isHolidaysCalendar) {
              if (this.getEndDate === this.getStartDate &&
                !day.newVacations
              ) {
                this.cancelHolidays(this.isHolidaysCalendar)
                this.cancelRemove()
                this.selectDay = this.getSelectDay
                this.morePos = this.computePos(jsEvent.target)
              }
              if (!this.selectDay.length && this.getEditingId) {
                this.cancelHolidays(this.isHolidaysCalendar)
                this.cancelRemove()
                this.selectDay = this.getSelectDay
              } else if (!this.selectDay.length && !this.getEditingId) {
                this.morePos = this.computePos(jsEvent.target)
              } else if (this.selectDay.length && this.getEditingId) {
                this.cancelHolidays(this.isHolidaysCalendar)
                this.cancelRemove()
                this.selectDay = this.getSelectDay
                this.setShowMore(this.title)
                this.morePos = this.computePos(jsEvent.target)
              }
              // this.morePos = this.computePos(jsEvent.target)
              if (!this.getStartDate) {
                this.cancelHolidays(this.isHolidaysCalendar)
                this.cancelRemove()
                this.selectDay = this.getSelectDay
                this.setShowMore(this.title)
                this.morePos = this.computePos(jsEvent.target)
              }

              if (this.getMe.remainingDays > 0 || this.getStartDate === '') {
                this.selectDay = this.getSelectDay
                this.selectDay.push(currentDay)

                let orderDates = this.selectDay
                .sort(function (a, b) {
                  return new Date('"' + a + '"') - new Date('"' + b + '"')
                })

                let min = orderDates[0]
                let max = orderDates[orderDates.length - 1]

                this.setSelectDay([min, max])

                this.setStartDate(this.getSelectDay[0])
                this.setEndDate(this.getSelectDay[this.getSelectDay.length - 1])
              } else if (this.getStartDate !== '') {
                if (this.getEndDate === this.getStartDate) {
                  this.morePos = this.computePos(jsEvent.target)
                }
              }
            } else {
              this.cancelHolidays(this.isHolidaysCalendar)
              this.cancelRemove()
              this.selectDay = this.getSelectDay
              this.setShowMore(this.title)
              this.morePos = this.computePos(jsEvent.target)
              this.setStartDate(currentDay)
            }

            this.updateEvents(this.isHolidaysCalendar)
          }
        }
      },
      computePos (target) {
        let eventRect = target.getBoundingClientRect()
        let pageRect = this.$refs.dates.getBoundingClientRect()

        let left = eventRect.left - pageRect.left
        let top = eventRect.top - pageRect.top

        if (eventRect.left < 150) {
          left = 125
          this.boxLeft = true
        } else {
          this.boxLeft = false
        }

        if (pageRect.top < 150) {
          top += 150 + eventRect.height
          this.boxTop = true
        } else {
          this.boxTop = false
        }

        return {
          left: left,
          top: top
        }
      },
      dispatchEvent () {
        this.title = dateFunc.format(
          this.headDate,
          this.titleFormat,
          this.monthNames
        )
        let m = new Date(this.currentDate)
        this.month = m.getMonth() + 1
      }
    }
  }
</script>

<style lang='css' src='./Month.css' scoped></style>



// WEBPACK FOOTER //
// Month.vue?316adbee